package at.theatervogelweide.admin.contract.board

import at.theatervogelweide.admin.contract.FieldError
import at.theatervogelweide.admin.contract.VersionedId
import at.theatervogelweide.admin.contract.people.fullName
import at.theatervogelweide.admin.contract.validate
import kotlinx.serialization.Serializable

/** A board member in the public site's order, with what the public site shows of the person. */
@Serializable
data class BoardMemberEntry(
    val id: Long,
    val version: Long,
    val personId: Long,
    val firstName: String,
    val lastName: String,
    val imageUuid: String?,
    val function: String,
) {
    val versionedId: VersionedId get() = VersionedId(id, version)

    val name: String get() = fullName(firstName, lastName)

    val draft: BoardMemberDraft get() = BoardMemberDraft(personId, function)
}

/** What the editor creates and saves: the person comes from Personen, the function is free text such as "Kassa". */
@Serializable
data class BoardMemberDraft(
    val personId: Long? = null,
    val function: String = "",
) {
    fun validate(): List<FieldError> = validate {
        check(PERSON, personId != null) { "Bitte eine Person auswählen." }
        field(FUNCTION, function) { required(); maxLength(255) }
    }

    companion object {
        const val PERSON = "person"
        const val FUNCTION = "function"
    }
}
